import React from "react";

const STEPS = [
  {
    step: "01",
    name: "Analýza prostor",
    description:
      "Přijedeme, zaměříme plochy, zhodnotíme materiály a frekvenci provozu.",
  },
  {
    step: "02",
    name: "Návrh řešení",
    description:
      "Připravíme harmonogram a cenovou kalkulaci šitou přesně na váš objekt.",
  },
  {
    step: "03",
    name: "Nasazení týmu",
    description:
      "Prověřený tým začne pracovat podle schváleného standardu i tempa.",
  },
  {
    step: "04",
    name: "Kontrola kvality",
    description:
      "Manažer pravidelně provádí audit a reaguje na vaši zpětnou vazbu.",
  },
];

const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-white py-20 md:py-28"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-10">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.28em] font-bold text-[#0F5C69]">
              [ 03 ] — Proces
            </div>
            <h2 className="font-display text-4xl md:text-6xl font-bold tracking-[-0.025em] leading-[1.02] mt-5">
              Jak to<br />funguje.
            </h2>
          </div>
          <p className="max-w-md text-[#222222] leading-relaxed font-medium text-base md:text-lg">
            Čtyři fáze, jedna odpovědnost. Od první návštěvy po dlouhodobou
            péči vás provází stejný manažer.
          </p>
        </div>

        <div
          data-testid="process-banner"
          className="mb-12 md:mb-16 bg-[#0F5C69] text-white px-8 md:px-12 py-6 md:py-7"
        >
          <p className="font-display text-lg md:text-xl lg:text-2xl font-semibold tracking-tight leading-snug max-w-4xl">
            Jasný proces od první schůzky po dlouhodobou spolupráci —{" "}
            <span className="text-white/70">
              bez překvapení v ceně i kvalitě.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
          {STEPS.map((s) => (
            <div
              key={s.step}
              data-testid={`process-step-${s.step}`}
              className="group relative bg-white p-7 md:p-8 flex flex-col hover:bg-[#E6F2F4] transition-colors duration-500"
            >
              <div
                data-testid={`process-step-badge-${s.step}`}
                className="w-12 h-12 rounded-xl bg-[#0F5C69] flex items-center justify-center shadow-sm transition-transform duration-200 ease-out motion-safe:[@media(hover:hover)]:group-hover:scale-110"
              >
                <span className="font-display text-base md:text-lg font-bold text-white tabular-nums leading-none">
                  {s.step}
                </span>
              </div>
              <div className="mt-6">
                <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight text-[#111111]">
                  {s.name}
                </h3>
                <p className="mt-3 text-sm text-[#555555] leading-relaxed">
                  {s.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
